(() => {
  if (window.__KamokProductGalleryV2) return;
  window.__KamokProductGalleryV2 = true;

  function modalItems(modal) {
    const content = modal.querySelector('.product-media-modal__content');
    return {
      content,
      items: content ? Array.from(content.children).filter((el) => el.hasAttribute?.('data-media-id')) : [],
    };
  }

  function updateModal(modal) {
    const { content, items } = modalItems(modal);
    if (!content || !items.length) return;
    const width = Math.max(1, content.clientWidth);
    let index = Math.round(content.scrollLeft / width);
    index = Math.max(0, Math.min(items.length - 1, index));
    modal.dataset.kamokGalleryIndex = String(index);

    const current = modal.querySelector('[data-kamok-gallery-current]');
    if (current) current.textContent = String(index + 1);

    const prev = modal.querySelector('[data-kamok-gallery-prev]');
    const next = modal.querySelector('[data-kamok-gallery-next]');
    if (prev) prev.disabled = index <= 0;
    if (next) next.disabled = index >= items.length - 1;
  }

  function goTo(modal, index, behavior = 'smooth') {
    const { content, items } = modalItems(modal);
    if (!content || !items.length) return;
    const safe = Math.max(0, Math.min(items.length - 1, index));
    content.scrollTo({ left: items[safe].offsetLeft, behavior });
    modal.dataset.kamokGalleryIndex = String(safe);
    if (behavior === 'auto') updateModal(modal);
  }

  function syncOpenedMedia(modal) {
    const { items } = modalItems(modal);
    if (!items.length) return;
    const mediaId = modal.openedBy?.dataset?.mediaId || '';
    let index = items.findIndex((item) => String(item.dataset.mediaId) === String(mediaId));
    if (index < 0) index = 0;
    requestAnimationFrame(() => goTo(modal, index, 'auto'));
  }

  function initModal(modal) {
    if (!modal || modal.dataset.kamokGalleryReady === '1') return;
    modal.dataset.kamokGalleryReady = '1';

    const { content } = modalItems(modal);
    if (!content) return;

    let timer;
    content.addEventListener('scroll', () => {
      clearTimeout(timer);
      timer = setTimeout(() => updateModal(modal), 80);
    }, { passive: true });

    modal.querySelector('.km-gallery-modal__nav')?.addEventListener('pointerup', (e) => e.stopPropagation());

    modal.querySelector('[data-kamok-gallery-prev]')?.addEventListener('click', (e) => {
      e.stopPropagation();
      goTo(modal, Number(modal.dataset.kamokGalleryIndex || 0) - 1);
    });

    modal.querySelector('[data-kamok-gallery-next]')?.addEventListener('click', (e) => {
      e.stopPropagation();
      goTo(modal, Number(modal.dataset.kamokGalleryIndex || 0) + 1);
    });

    modal.addEventListener('keydown', (e) => {
      const index = Number(modal.dataset.kamokGalleryIndex || 0);
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        goTo(modal, index - 1);
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        goTo(modal, index + 1);
      }
    });

    // Observe only this modal's "open" state, not the whole document.
    new MutationObserver(() => {
      if (modal.hasAttribute('open')) syncOpenedMedia(modal);
    }).observe(modal, { attributes: true, attributeFilter: ['open'] });

    updateModal(modal);
  }

  function init() {
    document.querySelectorAll('product-modal[data-kamok-gallery-modal]').forEach(initModal);
  }

  // One delegated click handler instead of listeners/observers on every thumbnail.
  document.addEventListener('click', (event) => {
    const button = event.target.closest?.('[data-kamok-gallery-thumb]');
    if (!button) return;

    const thumb = button.closest('[data-target]');
    const gallery = button.closest('media-gallery');
    const target = thumb?.dataset?.target;
    if (!gallery || !target) return;

    const media = gallery.querySelector('[data-media-id="' + target + '"]');
    const opener = media?.querySelector('.product__media-toggle');
    if (opener) {
      event.preventDefault();
      opener.click();
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();